import React from "react";
import { FallbackProps } from "./ErrorBoundary";
import { Button } from "../../Shared/Buttons/Button";

const ErrorPage = ({ error, resetErrorBoundary }: FallbackProps) => {
  console.error("ErrorPage", error.name, error.message, error.stack);
  return (
    <div className="ErrorPage flex flex-col flex-1 h-full p-panel-padding text-primary-color font-inter bg-page-background text-collins-md">
      <h2>There was an unexpected error.</h2>
      <h3>Please reload and try again.</h3>
      <div className="ErrorDetails overflow-auto h-0 grow">
        <div className="ErrorName pt-panel-padding">{error.name}</div>
        <div className="ErrorMessage pt-panel-padding">{error.message}</div>
        <div className="ErrorStack pt-panel-padding">{error.stack}</div>
      </div>
      <div className="ErrorButton pt-panel-padding">
        <Button type="primary" expand={true} onClick={resetErrorBoundary}>
          Reload
        </Button>
      </div>
    </div>
  );
};

export default ErrorPage;
